import React from "react";
import "./Certificates.css";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { Link } from "react-router-dom";

const Certificates = () => {
  return (
    <div id="certificates">
      <div id="certificates_Outer">
        <div id="certification_header">Certificates</div>
        <div id="certificates_Inner">
          <div className="certi">
            <img src="dsa1.jpg" alt="" />
          </div>
          <div className="certi">
            <img src="dbms1.jpg" alt="" />
          </div>
          <div className="certi" id="certi3">
            <img src="python1.jpg" alt="" />
          </div>
          <div  className="certi" id="certi_view_more" title="Click to view all certifications.">
          <Link to="https://www.linkedin.com/in/pratham-singh-800a0822a/details/certifications/"  target="__blank">
            <ArrowOutwardIcon id="view_more_icon"/>
          </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificates;
